import React from 'react'
import './CSS/Aboutme.css'
import Hr from './Hr'

const Aboutme = () => {
    return (
        <div className="">
            <div className="about-me">
                <div className="intro">
                    <h1>NGUYEN THI THO THY</h1>
                    <hr />
                    <p>Hi! I am Nguyen Thi Tho Thy, a third-year student majoring in Software Engineering at Gia Dinh University. I have a passion for programming and web design, especially with ReactJS. With a solid foundation in HTML, CSS, and JavaScript, I aim to apply my knowledge and skills to contribute to web projects. I am seeking an internship opportunity to develop my skills while learning and challenging myself in a professional environment at a company. In the future, I aspire to become a front-end web developer capable of building complex web applications and delivering the best web experience for users. I sincerely appreciate your time spent reading about me.</p>
                </div>
            </div>
            <Hr />
        </div>
    )
}

export default Aboutme
